import {
    Box,
    Button,
    List,
    ListItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/components/Superadmin/attachfiles.module.scss";
// import styles from "../../styles/pages/mymessage.module.scss";

import assest from "../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getAbsoluteDownloadURI } from "../../lib/functions/utils.lib";
import FileIcon from "../../ui/Icons/FileIcon";

const AttachFiles = (props) => {
    const handleDownload = (fileLink) => {
        window.open(getAbsoluteDownloadURI(fileLink), "_blank");
    };
    const shortenFileName = (fileName) => {
        if (fileName.length < 15) return fileName;
        var name = fileName.split(".")[0];
        var extenstion = "." + fileName.split(".").pop();
        return name.slice(0, 12) + "..." + name[name.length - 1] + extenstion;
    };
    return (
        <>
            <Box className={styles.msgdetails}>
                {props?.attachments?.length ? (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        className={styles.detailsTopHeading}
                    >
                        <Typography
                            variant="h3"
                            className={styles.headingStyled}
                        >
                            Attached Files
                        </Typography>
                    </Stack>
                ) : (
                    ""
                )}

                {props?.attachments?.length ? (
                    <Paper className={styles.styledPaper}>
                        <PerfectScrollbar
                            className={`${styles.showAttachFile} ${styles.forScroll}`}
                        >
                            <List>
                                {props?.attachments?.map((item, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <img
                                                src={assest.IconDwnarw}
                                                width={14}
                                                height={14}
                                                alt="icon"
                                                onClick={() =>
                                                    handleDownload(item?.file)
                                                }
                                            />
                                            <Typography variant="caption">
                                                {shortenFileName(item?.name)}
                                            </Typography>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </PerfectScrollbar>
                    </Paper>
                ) : (
                    <Paper
                        className={`${styles.styledPaper} ${styles.noAttachFile}`}
                    >
                        <FileIcon />
                        <Typography variant="caption">
                            No files attached yet.
                        </Typography>
                    </Paper>
                )}
            </Box>
            {/* ================================== */}
            {/* ======== FOR NO FILE START ======= */}

            {/* ================================== */}
            {/* ========= FOR NO FILE END ======== */}
        </>
    );
};

export default AttachFiles;
